import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import StatisticsCard from './StatisticsCard';
import { actionStatisticsService, ActionStatistics } from '../../services/ActionStatisticsService';

const CompletedActionsCard: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<ActionStatistics | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await actionStatisticsService.getCompletedActions();
                setData(result);
            } catch (error) {
                console.error('Error fetching completed actions:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleClick = () => {
        navigate('/tw/plano-de-acao?situacao=Finalizada');
    };

    return (
        <StatisticsCard
            title="Finalizadas"
            value={data?.count ?? 0}
            loading={loading}
            color="#4caf50"
            icon={<CheckCircleOutlineOutlinedIcon fontSize="large" />}
            subtitle="Ações finalizadas"
            onClick={handleClick}
        />
    );
};

export default CompletedActionsCard;
